import { createFileRoute } from '@tanstack/react-router';

import {
  auditLogParams,
  auditLogQueryOptions,
  auditLogSearchSchema,
  AuditLogPage,
} from '@/features/audit-log';

/** Every platform role reads the audit log. */
export const Route = createFileRoute('/_authed/audit-log')({
  staticData: { crumbKey: 'nav.auditLog', tours: ['platform.audit-log'] },
  validateSearch: auditLogSearchSchema,
  loaderDeps: ({ search }) => search,
  // A failed prefetch is not fatal: the page renders the error inline and retries.
  loader: ({ context, deps }) =>
    context.queryClient
      .infiniteQuery(auditLogQueryOptions(auditLogParams(deps)))
      .catch(() => undefined),
  component: AuditLogPage,
});
